import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { SessionIdleMonitorService } from 'core/services';
import { SessionIdleWarningDialogComponent } from './session-idle-warning-dialog/session-idle-warning-dialog.component';

@Component({
    selector: 'dc-session-idle-warning',
    templateUrl: './session-idle-warning.component.html',
    styleUrls: ['./session-idle-warning.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionIdleWarningComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    private dialogRef: MatDialogRef<SessionIdleWarningDialogComponent> | null = null;

    constructor(
        private dialog: MatDialog,
        private sessionIdleMonitorService: SessionIdleMonitorService,
    ) {}

    public ngOnInit(): void {
        this.sessionIdleMonitorService.state$
            .pipe(
                map(state => state.warning),
                distinctUntilChanged(),
                takeUntil(this.destroy$),
            )
            .subscribe(warning => this.toggleDialog(warning));
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.closeDialog();
    }

    private toggleDialog(warning: boolean): void {
        if (warning) {
            this.openDialog();
            return;
        }

        this.closeDialog();
    }

    private openDialog(): void {
        if (this.dialogRef) {
            return;
        }

        this.dialogRef = this.dialog.open(SessionIdleWarningDialogComponent, {
            width: '520px',
            panelClass: 'popup',
            autoFocus: false,
            restoreFocus: false,
            disableClose: true,
        });

        this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
        });
    }

    private closeDialog(): void {
        if (!this.dialogRef) {
            return;
        }

        this.dialogRef.close();
        this.dialogRef = null;
    }
}
